__turbopack_context__.v({
  "aboutContainer": "about-module__8TymFG__aboutContainer",
  "aboutContent": "about-module__8TymFG__aboutContent",
  "aboutImageContainer": "about-module__8TymFG__aboutImageContainer",
  "aboutSection": "about-module__8TymFG__aboutSection",
  "aboutText": "about-module__8TymFG__aboutText",
  "aboutTitle": "about-module__8TymFG__aboutTitle",
  "backgroundImage": "about-module__8TymFG__backgroundImage",
  "blurText": "about-module__8TymFG__blurText",
  "blurTextContainer": "about-module__8TymFG__blurTextContainer",
  "contentSection": "about-module__8TymFG__contentSection",
  "cyclingText": "about-module__8TymFG__cyclingText",
  "heroSection": "about-module__8TymFG__heroSection",
  "heroText": "about-module__8TymFG__heroText",
  "left": "about-module__8TymFG__left",
  "productCard": "about-module__8TymFG__productCard",
  "productImageWrapper": "about-module__8TymFG__productImageWrapper",
  "productOverlay": "about-module__8TymFG__productOverlay",
  "productsContainer": "about-module__8TymFG__productsContainer",
  "right": "about-module__8TymFG__right",
  "subtitle": "about-module__8TymFG__subtitle",
});
